/**
 * Controller: ProgramsInstanceEditRestoreModal
 */
angular.module('acme.view.application.programs.instance.edit.restoreModal.controllers', [])
.controller('ProgramsInstanceEditRestoreModalController', [ '$scope', '$uibModalInstance', 'currentEvent', function ($scope, $uibModalInstance, currentEvent) {

    $scope.errors = [];

    $scope.model = {};

    $scope.init = function() {
      this.model = currentEvent;
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);